module.exports = {
  context: {
    heading: 'History Highlights',
    items: [
      {
        heading: '1983',
        image: {
          src: 'https://picsum.photos/300/200',
          alt: 'alt Text',
          lazy: true,
          height: 200,
          width: 300
        },
        text: 'The North County Career Development Program was incorporated as a nonprofit company in July with original purpose to help individuals exiting from high school programs find meaningful work in the community.'
      },
      {
        heading: '1989',
        image: {
          src: 'https://picsum.photos/400/400',
          alt: 'alt Text',
          lazy: true,
          height: 400,
          width: 400
        },
        text: 'Service expansion into Fresno and Merced counties with Employment and Independent Living Services.'
      },
      {
        heading: '1994',
        text: 'The North County Career Development Program was incorporated as a nonprofit company in July with original purpose to help individuals exiting from high school programs find meaningful work in the community.'
      },
      {
        heading: '1996',
        image: {
          src: 'https://picsum.photos/300/400',
          alt: 'alt Text',
          lazy: true,
          height: 300,
          width: 400
        },
        text: ' Development of our Individualized Transportation Program Services (TRIPS).'
      },
      {
        heading: '1998',
        text: 'Development of our first Crisis Residential Facility named the Longview House in Stockton, CA.'
      },
      {
        heading: '1999',
        text: 'Became known as Client Development Programs (CDP). Service expansion into Santa Clara, Monterey, Santa Cruz and San Benito counties with Independent Living Services. Service expansion into Coalinga, CA with a community-based day Program.  Broadened types of employment services offered in Central and Southern California to include External Situational Services.'
      },
      {
        heading: '2001',
        text: 'Became known as Community Catalysts of California. Service expansion into Lake and Mendocino counties. Moved and renamed the Longview House in Stockton, CA to the HYDE House. Development of community based Social and Recreational Program Services in Fresno and Merced counties.'
      },
      {
        heading: '2004',
        text: 'Service expansion into Contra Costa and Alameda counties with Supported Living services.'
      },
      {
        heading: '2006',
        text: 'Development of PLUM House, our second Adult Residential Facility in Ukiah, CA.'
      },
      {
        heading: '2008',
        text: 'Development of PACE House, our third step-away Adult Residential Facility in Stockton, CA. Development of Coffee Creations Cart a client managed micro-business enterprise in San Diego.'
      },
      {
        heading: '2009',
        text: 'Service expansion into Sacramento county with a crisis Adult Residential Facility in Elk Grove, CA.  Developed first Supported Living Residential Home in Visalia, CA named Encina House.'
      },
      {
        heading: '2010',
        text: 'Established our first military initiative and began our Veterans Community Services Division with a grant from SAMHSA, Substance Abuse and Mental Health Services providing intensive behavioral case management services for Veterans.'
      },
      {
        heading: '2011',
        text: 'Secured grant from the Department of Veteran Affairs to provide Supportive Services for Veteran Families (SSVF) Program under our Veterans Community Services Division.'
      },
      {
        heading: '2015',
        text: 'Secured a second grant from the Department of Veteran Affairs to expand our SSVF Program to six locations serving 750 Veteran families in San Diego, Imperial Valley and Riverside counties.'
      },
      {
        heading: '2021',
        text: 'Adjoin'
      }
    ]
  }
}
